import {
  DESTROY_DOCUMENT_DATA,
  DESTROY_USER_STATE_INFO,
  USER_DOCUMENTS_INFO,
  USER_LOGGED_IN_STATE,
  USER_STATE_INFO,
  SET_INSTAPOINTS_LOGIC_DATA,
  SET_USER_ADDRESS_INFO,
  SET_USER_ADDRESS_ERROR,
  DISABLE_PERSONAL_DETAILS_FILEDS,
  TOGGLE_FEATURE_STATE,
  SET_HELPCENTER_NOTIFICATION_DATA,
  USER_FLOW_JUMP_TO,
  USER_FLOW_NEXT
} from '../../action-contants';
import { handleError } from '../common-message/message-action';
import { API_URL, REQ_TIMEOUT } from '../../../utils/config';
import { submitAppointment } from '../schedule-interview/schedule-interview';
import {
  SINGPASS_CODE,
  INDIVIDUAL_POI,
  SCREEN_NAME_PERSONAL_DETAILS,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  SCREEN_NAME_PHOTO_UPLOAD,
  CORPORATE
} from '../../../utils/constants';
import { updateScreenConfig, changeScreen } from '../user-flow/user-flow-action';
import { makeApiCall } from '../common/common-action';
import { store } from '../../../store';
import get from 'lodash/get';

export function destroyUserStateInfo() {
  let data = null;
  return (dispatch) => {
    //update the screens
    dispatch({
      type: DESTROY_USER_STATE_INFO,
      data
    });
    return {};
  };
}

export function toggleFeature(data) {
  return {
    type: TOGGLE_FEATURE_STATE,
    data
  };
}
export function destroyDocumentData() {
  return (dispatch) => {
    dispatch({
      type: DESTROY_DOCUMENT_DATA
    });
  };
}

function userLoggedIn(data) {
  return {
    type: USER_LOGGED_IN_STATE,
    data
  };
}

function userStateInfo(data) {
  return {
    type: USER_STATE_INFO,
    data
  };
}

export function userDocumentsInfo(data) {
  return {
    type: USER_DOCUMENTS_INFO,
    data
  };
}

export function userAuthenticationRequest() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/user`,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        dispatch(userLoggedIn({ logged_in: true, data: response.data.data }));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      throw error.response;
    }
  };
}

export function storeInstapointsLogic(data) {
  return {
    type: SET_INSTAPOINTS_LOGIC_DATA,
    instaPointsLogicData: data
  };
}

export function getNewUserFlow(account_type) {
  let url;
  if (account_type === CORPORATE) {
    url = `${API_URL}/remitter/corporate`;
  } else {
    url = `${API_URL}/remitter/individual`;
  }
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        let requiredData = response.data.data;
        if (requiredData.statusCode) {
          delete requiredData.statusCode;
        }
        if (requiredData.onfido_check_created) {
          dispatch(updateScreenConfig(SCREEN_NAME_PHOTO_UPLOAD, { is_required: false }));
        }
        dispatch(userStateInfo(requiredData));
        let { remitterDetails } = requiredData;
        if (remitterDetails) {
          let {
            appointment_request_id,
            scheduled_date,
            scheduled_slot,
            appointment_address_type,
            appointment_address
          } = remitterDetails;
          appointment_request_id &&
            dispatch(
              submitAppointment({
                appointment_request_id,
                scheduled_date,
                scheduled_slot,
                appointment_address_type,
                appointment_address
              })
            );
        }
      } else {
        dispatch(userStateInfo(null));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getInstapointsLogic() {
  const reduxStore = store.getState();
  const isAmazeUser = get(
    reduxStore,
    'rootReducer.userSessionReducer.user_session.is_amaze_customer',
    false
  );
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/config?amaze_config=${isAmazeUser}`,
        method: 'get',
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        dispatch(storeInstapointsLogic(response.data.data));
        dispatch(storeHelpcenterNotificationData(response.data.data.help_center_notification));
        return response.data.data;
      } else return null;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getUserDocuments() {
  const reduxStore = store.getState();
  const userSession = get(reduxStore, 'rootReducer.userSessionReducer.user_session', {});
  const country_code = userSession?.country_code;

  return async (dispatch, getState) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/remitter/document-details`,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        if (response.data.data && response.data.data.length) {
          let singpassDocPOI = response.data.data.find(
            (key) =>
              key.document_code === SINGPASS_CODE &&
              key.type === INDIVIDUAL_POI &&
              key.status === 'APPROVED'
          );
          if (singpassDocPOI) {
            dispatch(
              updateScreenConfig(SCREEN_NAME_PHOTO_UPLOAD, {
                is_required: false
              })
            );
            dispatch(
              updateScreenConfig(SCREEN_NAME_DOCUMENT_UPLOAD, {
                is_required: false
              })
            );
            let { screens, timeline, currentScreen } = getState().rootReducer.userFlowReducer;
            if (currentScreen !== SCREEN_NAME_PERSONAL_DETAILS) {
              if (country_code === 'SG') {
                dispatch(
                  changeScreen(USER_FLOW_JUMP_TO, SCREEN_NAME_PERSONAL_DETAILS, screens, timeline)
                );
              } else {
                dispatch(
                  changeScreen(USER_FLOW_NEXT, SCREEN_NAME_PERSONAL_DETAILS, screens, timeline)
                );
              }
            }
          }
        }

        const remitterDetails = get(
          reduxStore,
          'rootReducer.userDataReducer.userStateInfo.remitterDetails',
          {}
        );
        const status = remitterDetails?.status;
        const isPerSGResident = remitterDetails?.is_permanent_sg_resident;

        const renderPOA = country_code === 'SG' && status === 'INITIATED' && !isPerSGResident;

        !renderPOA && dispatch(userDocumentsInfo(response.data.data));
      }
      const isSingPass = response.data.data.find((obj) => obj.document_code === 'SINGPASS');
      response.data.data.length > 0 &&
        !isSingPass &&
        dispatch({ type: DISABLE_PERSONAL_DETAILS_FILEDS });
      // response.data.data.length > 0 && dispatch({type:DISABLE_PERSONAL_DETAILS_FILEDS})
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getTransactionData() {
  return async (dispatch, getState) => {
    let temp_transaction_id =
      getState().rootReducer.transactionReducer.transactionDetails.temp_transaction_id;
    try {
      let response = await makeApiCall({
        url: `${API_URL}/transaction/${temp_transaction_id}`,
        method: 'get',
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        dispatch(userStateInfo(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getUserProfileData(isNiumForexUser = false) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        url: isNiumForexUser
          ? `${API_URL}/niumForex/remitter/details`
          : `${API_URL}/remitter/user/profile`,
        method: 'get',
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
}

export function setAddressInfo(payload) {
  return (dispatch) => {
    try {
      dispatch({
        type: SET_USER_ADDRESS_INFO,
        userAddressInfo: payload
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('address error:', error);
    }
  };
}
export function setAddressError(error) {
  return {
    type: SET_USER_ADDRESS_ERROR,
    error
  };
}

export function storeHelpcenterNotificationData(data) {
  return {
    type: SET_HELPCENTER_NOTIFICATION_DATA,
    helpCenterNotificationData: data
  };
}
